import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MCheck from '@mui/material/Checkbox';

const Checkbox = (props) => {
	const {
		onChange,
		checkedValue,
		uncheckedValue,
		value,
		label,
		name,
		sx,
		disabled,
		...otherProps
	} = props;

	const changeHandler = (event) => {
		const value = event.target.checked ? (checkedValue || true) : (uncheckedValue || false);
		onChange({
			target: { name, value },
		});
	};
	return (
		<FormControlLabel
			control={<MCheck checked={value} onChange={changeHandler} />}
			label={label}
			sx={{ width: '100%', ...sx }}
			disabled={disabled}
			{...otherProps}
		/>
	);
};

Checkbox.type = 'Checkbox';

Checkbox.spec = [{
	name: 'Checkbox',
	key: 'Checkbox',
	icon: 'CheckSquare',
	title: 'Checkbox',
	category: 'input',
	translatable: ['label'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];

export default Checkbox;